module.exports = require("./ms-Arab");